/*
 **	Material Icons Component using Google Material Icons font
 **	OMNI_IQ Mobile (c) 2025 Silver Falls Capital. All Rights Reserved
 */

import React from 'react'

interface MaterialIconProps {
  name: string
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

export const MaterialIcon: React.FC<MaterialIconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  style = {}
}) => {
  return (
    <span
      className={`material-icons ${className}`}
      style={{
        fontSize: `${size}px`,
        color: color,
        lineHeight: 1,
        userSelect: 'none',
        ...style,
      }}
    >
      {name}
    </span>
  )
}